"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTACT_METHOD_VERIFICATION_TYPE = void 0;
exports.CONTACT_METHOD_VERIFICATION_TYPE = {
    SIGNIN: 'signin',
    UPDATE: 'update',
};
//# sourceMappingURL=contact-method-verification.types.js.map